import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
export const usePayerUpdate = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("usePaymethodcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `usePayerUpdate-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `usePayerUpdate-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `usePayerUpdate-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const updateIdCard = async (params:CustomQuery) => {
    try {
      loading.value = true;
      const res = await context.$xbuy.api.payerUpdate(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res.data;
        error.value.load = null;
      } else {
        error.value.load = new Error(res.message);
      }
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
  };

  return {
    updateIdCard,
    result: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
